import { Badge, SpaceBetween } from '@cloudscape-design/components';
import PropTypes from 'prop-types';
import React from 'react';

import { usePartAndQuote } from '../../features/firebase';

function QuoteStatus({ partId }) {
  const { part, quote, status: queryStatus } = usePartAndQuote(partId);
  const { hasBeenOrdered, isParallelShared } = part;
  const { status, isBudgetary } = quote;

  let tagText = 'Unknown';
  if (hasBeenOrdered && !isParallelShared) {
    tagText = 'Ordered';
  } else {
    tagText = {
      quoted: 'Quoted',
      pending: 'Pending',
      no_quote: 'No quote',
    }[status] || 'Unknown';
  }

  if (queryStatus === 'loading') {
    tagText = 'Loading...';
  }

  return (
    <SpaceBetween direction="horizontal" size="xs">
      <Badge
        color={{
          Quoted: 'green',
          Pending: 'grey',
          Ordered: 'blue',
          'No quote': 'red',
          Unknown: 'grey',
          'Loading...': 'grey',
        }[tagText] || 'grey'}
      >
        {tagText}
      </Badge>
      {isBudgetary && <Badge color="severity-medium">Budgetary</Badge>}
      {isParallelShared && <Badge color="severity-low">Parallel Shared</Badge>}
    </SpaceBetween>
  );
}

QuoteStatus.propTypes = {
  partId: PropTypes.string.isRequired,
};

export default QuoteStatus;
